<template>
  <x-button class="logout-button full-width" @click="exit">
    <ic-logout class="icon-logout" />
    {{ $t('buttons.logout') }}
  </x-button>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import icLogout from '@/svg/ic-logout'

export default {
  name: 'LogoutButton',

  components: {
    icLogout
  },

  methods: {
    exit() {
      this.logOut()
        .finally(() => {
          this.setConnectionWithSSO(false)
          this.saveUserCreated(false)

          this.$router.push({
            name: 'login'
          })
        })
    },

    ...mapActions({
      logOut: 'auth/logOut'
    }),
    ...mapMutations({
      setConnectionWithSSO: 'setConnectionWithSSO',
      saveUserCreated: 'auth/saveUserCreated'
    })
  }
}
</script>

<style lang="scss" scoped rel="stylesheet/scss">
@import '~@/styles/vars.scss';

.icon-logout {
  width: 1.4rem;
  height: 1.8rem;
}
</style>
